import React, { useMemo } from 'react';
import { Trophy, Crown } from 'lucide-react';

// Shows the paid competition entries linked to a ConsumerAccount, displayed
// inside the expanded account row in the Consumer Accounts tab so paid
// competition sales are allocated to the customer's account.

const fmt = (n) => `£${(Number(n) || 0).toFixed(2)}`;

export default function ConsumerAccountEntriesPanel({ accountId, entries }) {
  const mine = useMemo(
    () => (entries || []).filter((e) => e.consumer_account_id === accountId),
    [entries, accountId]
  );

  if (mine.length === 0) {
    return (
      <p className="text-white/30 text-[11px]">No paid competition entries.</p>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-primary/80 text-[10px] font-bold tracking-widest flex items-center gap-1.5">
        <Trophy className="w-3 h-3" /> PAID COMPETITION ENTRIES ({mine.length})
      </p>
      <div className="border border-white/10 divide-y divide-white/5">
        {mine.map((e) => (
          <div key={e.id} className="flex items-center gap-3 px-3 py-2 text-xs">
            <span className="text-white/40 text-[11px] w-28 shrink-0">
              {e.created_date ? new Date(e.created_date).toLocaleDateString('en-GB') : '—'}
            </span>
            <span className="text-orange-400 font-mono text-[11px] w-20 shrink-0">{e.rig_draw_period || '—'}</span>
            <span className="text-white/60 flex-1 truncate">Sim Rig Draw entry</span>
            {e.is_winner && (
              <span className="inline-flex items-center gap-1 text-[9px] font-bold tracking-widest border border-yellow-400/40 text-yellow-400 px-1.5 py-0.5">
                <Crown className="w-3 h-3" /> WINNER
              </span>
            )}
            <span className="text-white font-bold w-14 text-right">{fmt(e.paid_amount)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}